var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"holder",staticClass:"auto-heading"},[_c(_vm.tag,{ref:"text",tag:"component",staticClass:"auto-heading__text",class:[
      _vm.fontClass,
      {
        'auto-heading__text--too-long': _vm.tooDamnLong
      }
    ],style:({ fontSize: `${_vm.getCurrentFontSize}rem` }),attrs:{"id":_vm.id}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }